import { SecurityZonesModelBase } from './security-zones-model';
import { ZoneFeature, Zones } from './zones-base-interfaces';
import { authFetchGET } from '../utils/auth-fetch';
const env = (<any>window).appenv.services.staticdataapi;

export class SecurityZonesModelImpl extends SecurityZonesModelBase {
    async getSecurityZones(): Promise<ZoneFeature[] | null> {
        await this._loadingPromise;

        const securityZones = this._zones!.features;
        return securityZones;
    }

    constructor(geojson?: Zones) {
        super();

        if (geojson) {
            this._zones = geojson;
        } else {
            this._loadingPromise = this._loadGeoJson();
            setInterval(() => this._loadGeoJson(), 60*60*1000); // refresh the list every 1h
        }
    }

    private _zones: Zones | null = null;
    private _loadingPromise: Promise<void> | null = null;

    private async _loadGeoJson() {
        const zones : Zones = ( await authFetchGET(env.scope, `${env.baseurl}/v1/SecurityZones`));
        if (zones) {
            this._zones = zones;
        }
    }
}
